import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from '../iconVariant';
import { IconProps } from '../types/IconInterface';

// The small icon on the circle avatar of the transaction details in this design:
// https://www.figma.com/design/bblnSSOHdRw4VImNVChx2K/Emerge-Customer-Web-Portal?node-id=6114-32811&t=dK9bbYlUWIaMxydA-4
const ReceiptRequiredIcon = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    viewBox="0 0 9 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.10007 0.599991C0.603017 0.599991 0.200073 1.00293 0.200073 1.49999V9.29999C0.200073 9.79705 0.603017 10.2 1.10007 10.2H7.70007C8.19713 10.2 8.60007 9.79705 8.60007 9.29999V3.97278C8.60007 3.73409 8.50525 3.50517 8.33647 3.33639L5.86368 0.863595C5.69489 0.694812 5.46598 0.599991 5.22728 0.599991H1.10007ZM4.40007 4.19999C4.6486 4.19999 4.85007 4.40146 4.85007 4.64999V5.54999H5.75007C5.9986 5.54999 6.20007 5.75146 6.20007 5.99999C6.20007 6.24852 5.9986 6.44999 5.75007 6.44999H4.85007V7.34999C4.85007 7.59852 4.6486 7.79999 4.40007 7.79999C4.15155 7.79999 3.95007 7.59852 3.95007 7.34999V6.44999H3.05007C2.80154 6.44999 2.60007 6.24852 2.60007 5.99999C2.60007 5.75146 2.80154 5.54999 3.05007 5.54999H3.95007V4.64999C3.95007 4.40146 4.15155 4.19999 4.40007 4.19999Z"
      fill="currentColor"
    />
  </svg>
);

export default ReceiptRequiredIcon;
